import * as types from './action-types';
import * as endpoints from '../helpers/endpoints';
import apiRequest from '../helpers/apiRequest';
import _ from 'lodash';
import { actions } from 'react-redux-form';

/**
 * This function will populate list of assignment options inside the dropdown base on the user billet location
 **/
export const assignmentOptionsThunk = () => (dispatch, getState) => {
    const userBilletLocation = getState().data.userInfo.Billet.location;
    const listOfBillets = {
        /* prettier-ignore */
        MCRC: () => `${endpoints.ASSIGNED_LOCATION_REGION_LIST}?include=District.RS.RSS,District.RS.*OSS`,
        /* prettier-ignore */
        RSS: () => `${endpoints.ASSIGNED_LOCATION_RSS_LIST}?filter[active]=1&filter[id]=${getState().data.userInfo.RSS.id}`,
        /* prettier-ignore */
        OSS: () => `${endpoints.ASSIGNED_LOCATION_OSS_LIST}?filter[active]=1&filter[id]=${getState().data.userInfo.OSS.id}`,
        /* prettier-ignore */
        RS: () => `${endpoints.ASSIGNED_LOCATION_RS_LIST}?include=RSS,OSS&filter[OSS.active]=1&filter[RSS.active]=1&filter[id]=${getState().data.userInfo.RS.id}`,
        /* prettier-ignore */
        District: () => `${endpoints.ASSIGNED_LOCATION_DISTRICT_LIST}?include=RS,RS.RSS,RS.*OSS&filter[id]=${getState().data.userInfo.District.id}`,
        /* prettier-ignore */
        Regional: () => `${endpoints.ASSIGNED_LOCATION_REGION_LIST}?include=District.RS.RSS,District.RS.*OSS&filter[id]=${getState().data.userInfo.regionId}`,
        /* prettier-ignore */
        PSRSS: () => `${endpoints.ASSIGNED_LOCATION_PSS_LIST}?filter[active]=1&filter[id]=${getState().data.userInfo.PSRSS.id}`
    };
    if (userBilletLocation === 'Other') {
        let other = [
            {
                type: 'Other',
                code: userBilletLocation,
                name: 'Other'
            }
        ];
        let dataCollection = [];
        dataCollection = [...other];
        dataCollection = _.groupBy(dataCollection, option => {
            return option.type;
        });

        dispatch(assignmentOptionsSuccess(dataCollection));
    } else {
        apiRequest(
            listOfBillets[userBilletLocation](),
            getState().auth.jwtToken,
            'GET',
            undefined,
            false,
            2
        ).then(payload => {
            if (!payload.errors) {
                dispatch(
                    assignmentOptionsSuccess(
                        formatOptions(payload, userBilletLocation)
                    )
                );
            } else {
                console.log(payload.errors);
            }
        });
    }
};

export const assignmentOptionsSuccess = payload => ({
    type: types.ASSIGNMENT_OPTIONS,
    payload
});

export const formatOptions = (payload, userBilletLocation) => {
    let includedProp = [],
        dataCollection;
    let dataProp = [];
    const listOfValues = {
        ChainOfCommand: 1,
        Region: 2,
        District: 3,
        RS: 4,
        RSS: 5,
        OSS: 6
    };
    if (userBilletLocation === 'MCRC' || userBilletLocation === 'PRSS') {
        dataProp = payload.data.map(val => {
            let order = listOfValues[val.type];
            return {
                type: val.type,
                code: val.id,
                name: val.attributes.name,
                order: order
            };
        });
    }
    dataProp = _.sortBy(dataProp, 'name');
    if (payload.included) {
        includedProp = payload.included.map(val => {
            let order = listOfValues[val.type];
            if (val.type === 'PSS') {
                return {
                    type: 'PSRSS',
                    code: val.id,
                    name: val.attributes.name,
                    order: order
                };
            } else {
                return {
                    type: val.type,
                    code: val.id,
                    name: val.attributes.name,
                    order: order
                };
            }
        });
    }
    includedProp = _.sortBy(includedProp, 'name');
    let chainOfCommand = [
        {
            type: 'ChainOfCommand',
            code: userBilletLocation,
            name: 'Chain of Command',
            order: 1
        }
    ];

    dataCollection = [...chainOfCommand, ...dataProp, ...includedProp];
    dataCollection = _.groupBy(dataCollection, option => {
        return option.order;
    });
    if (dataCollection[3]) {
        dataCollection[3] = _.sortBy(dataCollection[3], 'code');
    }
    return dataCollection;
};

/**
 * This function will populate list of assignees dropdown base off of the assignment option selection
 **/
export const assigneeOptionsThunk = e => (dispatch, getState) => {
    if (e.target.value === 'null') {
        dispatch(assigneeOptionsSuccess([]));
        return false;
    }
    dispatch(assigneeLoading());
    const userBilletLocation = getState().data.userInfo.Billet.location;
    const userId = getState().data.userInfo.id;
    const userRegionId = getState().data.userInfo.regionId;
    /* prettier-ignore */
    const selectedAssignmentType = e.target[e.target.selectedIndex].getAttribute('data-type');

    const selectedValue = e.target[e.target.selectedIndex].getAttribute(
        'data-value'
    );

    let chainOfCommandFilters = '';
    let chainOfCommandFiltersOther = '';

    /* prettier-ignore */
    chainOfCommandFiltersOther = `${endpoints.AUTH_USER_SEARCH}?ver=1&filter[isActive]=1&fields[User]=id,firstName,lastName,rank,isActive&include=Billet,MappedUsername&fields[Billet]=id,name&filter[Billet.location]=${userBilletLocation}&filter[id][ne]=${userId}&filter[Billet.name][in]=Agency&filter[Billet.name][in]=Other&order[Billet.name]=asc&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1`;

    // MCRC
    if (userBilletLocation === 'MCRC') {
        /* prettier-ignore */
        chainOfCommandFilters = `${endpoints.AUTH_USER_SEARCH}?ver=1&filter[isActive]=1&fields[User]=id,firstName,lastName,rank,isActive&include=Billet,MappedUsername&fields[Billet]=id,name&filter[Billet.location]=${userBilletLocation}&filter[id][ne]=${userId}&order[Billet.name]=asc&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1`;
    }
    // Regional
    if (userBilletLocation === 'Regional') {
        /* prettier-ignore */
        chainOfCommandFilters = `${endpoints.AUTH_USER_SEARCH}?ver=1&filter[isActive]=1&fields[User]=id,firstName,lastName,rank,isActive&include=Billet,MappedUsername&fields[Billet]=id,name&filter[id][ne]=${userId}&filter[Region.code]=${getState()
            .data.userInfo
            .regionCode}&filter[Billet.location]=${userBilletLocation}&order[Billet.name]=asc&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1`;
    }
    // District
    if (userBilletLocation === 'District') {
        /* prettier-ignore */
        chainOfCommandFilters = `${endpoints.AUTH_USER_SEARCH}?ver=1&filter[isActive]=1&fields[User]=id,firstName,lastName,rank,isActive&include=Billet,MappedUsername&fields[Billet]=id,name&filter[id][ne]=${userId}&filter[User.districtId]=${getState()
            .data.userInfo.District.id}&filter[Billet.location]=${userBilletLocation}&order[Billet.name]=asc&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1`;
    }
    // RS
    if (userBilletLocation === 'RS') {
        /* prettier-ignore */
        chainOfCommandFilters = `${endpoints.AUTH_USER_SEARCH}?ver=1&filter[isActive]=1&fields[User]=id,firstName,lastName,rank,isActive&include=Billet,MappedUsername&fields[Billet]=id,name&filter[id][ne]=${userId}&filter[User.recruitingStationId]=${getState()
            .data.userInfo.RS.id}&filter[Billet.location]=${userBilletLocation}&order[Billet.name]=asc&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1`;
    }
    // RSS
    if (userBilletLocation === 'RSS') {
        /* prettier-ignore */
        chainOfCommandFilters = `${endpoints.AUTH_USER_SEARCH}?ver=1&filter[isActive]=1&fields[User]=id,firstName,lastName,rank,isActive&include=Billet,MappedUsername&fields[Billet]=id,name&filter[id][ne]=${userId}&filter[User.recruitingSubStationId]=${getState()
            .data.userInfo.RSS.id}&filter[Billet.location]=${userBilletLocation}&order[Billet.name]=asc&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1`;
    }
    // OSS
    if (userBilletLocation === 'OSS') {
        /* prettier-ignore */
        chainOfCommandFilters = `${endpoints.AUTH_USER_SEARCH}?ver=1&filter[isActive]=1&fields[User]=id,firstName,lastName,rank,isActive&include=Billet,MappedUsername&fields[Billet]=id,name&filter[id][ne]=${userId}&filter[ossId]=${getState()
            .data.userInfo.OSS.id}&filter[Billet.location]=${userBilletLocation}&order[Billet.name]=asc&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1`;
    }
    const listOfBillets = {
        /* prettier-ignore */
        Other: () => `${chainOfCommandFiltersOther}`,
        /* prettier-ignore */
        ChainOfCommand: () => `${chainOfCommandFilters}`,
        /* prettier-ignore */
        RSS: () => `${endpoints.AUTH_USER_SEARCH}?ver=1&filter[isActive]=1&fields[User]=id,firstName,lastName,rank,isActive&include=Billet,MappedUsername&fields[Billet]=id,name,location&filter[recruitingSubStationId]=${selectedValue}&filter[Billet.name][in]=SNCOIC,OSO,OSA,XO,CO,Ops Officer,MPA,MAC,MPAO,RAO,MACO,AMACO,Public Affairs,Marketing Chief,Communication Chief,AAOP,EMV Team,JWT,Marketing Specialist,WRR Marketing Specialist,ERR Marketing Specialist,MCRC Marketing,MCRC Communication,MCRC Advertising,UWG,Agency&filter[Billet.location]=RSS&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1&order[Billet.name]=asc`,
        /* prettier-ignore */
        OSS: () => `${endpoints.AUTH_USER_SEARCH}?ver=1&filter[isActive]=1&fields[User]=id,firstName,lastName,rank,isActive&include=Billet,MappedUsername&fields[Billet]=id,name,location&filter[ossId]=${selectedValue}&filter[Billet.name][in]=SNCOIC,OSO,OSA,XO,CO,Ops Officer,MPA,MAC,MPAO,RAO,MACO,AMACO,Public Affairs,Marketing Chief,Communication Chief,AAOP,EMV Team,JWT,Marketing Specialist,WRR Marketing Specialist,ERR Marketing Specialist,MCRC Marketing,MCRC Communication,MCRC Advertising,UWG,Agency&filter[Billet.location]=OSS&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1&order[Billet.name]=asc`,

        RS: () =>
            `${
                endpoints.AUTH_USER_SEARCH
            }?ver=1&filter[isActive]=1&fields[User]=id,firstName,lastName,rank,isActive&include=Billet,MappedUsername&fields[Billet]=id,name,location&filter[recruitingStationId]=${selectedValue}&filter[Billet.name][in]=SNCOIC,OSO,OSA,XO,CO,Ops Officer,MPA,MAC,MPAO,RAO,MACO,AMACO,Public Affairs,Marketing Chief,Communication Chief,AAOP,EMV Team,JWT,Marketing Specialist,WRR Marketing Specialist,ERR Marketing Specialist,MCRC Marketing,MCRC Communication,MCRC Advertising,UWG,Agency&filter[Billet.location]=RS&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1&order[Billet.name]=asc`,
        /* prettier-ignore */
        District: () => `${endpoints.AUTH_USER_SEARCH}?ver=1&filter[isActive]=1&fields[User]=id,firstName,lastName,rank,isActive&include=Billet,MappedUsername&fields[Billet]=id,name,location&filter[districtId]=${selectedValue}&filter[Billet.name][in]=SNCOIC,OSO,OSA,XO,CO,Ops Officer,MPA,MAC,MPAO,RAO,MACO,AMACO,Public Affairs,Marketing Chief,Communication Chief,AAOP,EMV Team,JWT,Marketing Specialist,WRR Marketing Specialist,ERR Marketing Specialist,MCRC Marketing,MCRC Communication,MCRC Advertising,UWG,Agency&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1&filter[Billet.location]=District&order[Billet.name]=asc`,
        /* prettier-ignore */
        Region: () => `${endpoints.AUTH_USER_SEARCH}?ver=1&filter[isActive]=1&fields[User]=id,firstName,lastName,rank,isActive&include=Billet,MappedUsername&fields[Billet]=id,name,location&filter[Region.id]=${selectedValue}&filter[Billet.name][in]=SNCOIC,OSO,OSA,XO,CO,Ops Officer,MPA,MAC,MPAO,RAO,MACO,AMACO,Public Affairs,Marketing Chief,Communication Chief,AAOP,EMV Team,JWT,Marketing Specialist,WRR Marketing Specialist,ERR Marketing Specialist,MCRC Marketing,MCRC Communication,MCRC Advertising,UWG,Agency&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1&filter[Billet.location]=Regional&order[Billet.name]=asc`,

        PSRSS: () =>
            `${
                endpoints.AUTH_USER_SEARCH
            }?ver=1&filter[isActive]=1&fields[User]=id,firstName,lastName,rank,isActive&include=Billet,MappedUsername&fields[Billet]=id,name,location&filter[pssId]=${selectedValue}&filter[Billet.name][in]=SNCOIC,OSO,OSA,XO,CO,Ops Officer,MPA,MAC,MPAO,RAO,MACO,AMACO,Public Affairs,Marketing Chief,Communication Chief,AAOP,EMV Team,JWT,Marketing Specialist,WRR Marketing Specialist,ERR Marketing Specialist,MCRC Marketing,MCRC Communication,MCRC Advertising,UWG,Agency&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1&order[Billet.name]=asc`
    };
    apiRequest(
        listOfBillets[selectedAssignmentType](),
        getState().auth.jwtToken,
        'GET',
        undefined,
        false,
        2
    ).then(payload => {
        dispatch(assigneeLoading());
        dispatch(
            assigneeOptionsSuccess(
                formatAssigneeOptions(
                    payload,
                    selectedAssignmentType,
                    selectedValue,
                    userBilletLocation,
                    userRegionId
                )
            )
        );
    });
};

export const assigneeLoading = () => ({
    type: types.ASSIGNEE_LOADING
});

export const assigneeOptionsSuccess = payload => ({
    type: types.ASSIGNEE_OPTIONS,
    payload
});

export const formatAssigneeOptions = (
    payload,
    selectedAssignmentType,
    selectedValue,
    userBilletLocation,
    userRegionId
) => {
    const nonReadOnlyUsers = [
        'SNCOIC',
        'OSO',
        'OSA',
        'Ops Officer',
        'XO',
        'CO',
        'MAC',
        'MPA',
        'AAOP',
        'EMV Team',
        'AMACO',
        'MACO',
        'Marketing Chief',
        'Communication Chief',
        'Marketing Specialist',
        'ERR Marketing Specialist',
        'WRR Marketing Specialist',
        'JWT',
        'MCRC Advertising',
        'MCRC Marketing',
        'Communication Chief',
        'MCRC Communication',
        'UWG',
        'Commanding General',
        'Community Engagement Officer',
        'Community Engagement Chief',
        'Community Engagement NCO',
        'Action Officer',
        'Agency'
    ];
    const mappedResults = payload.data.map(val => {
        let billetName = '';
        if (!!val.Billet) {
            billetName = `${val.Billet.name} - `;
        }
        return {
            code: val.id,
            billetName: val.Billet.name,
            name: `${billetName}${val.rank} ${val.firstName} ${val.lastName}`,
            billetLocation: val.Billet.location
        };
    });
    const filteredResults = [];
    mappedResults.forEach(item => {
        let nonReadOnly = nonReadOnlyUsers.includes(item.billetName);

        if (nonReadOnly === true) {
            if (item.billetName !== 'Marketing Specialist') {
                if (selectedAssignmentType === 'Region') {
                    if (
                        selectedValue === '1' &&
                        item.billetName !== 'WRR Marketing Specialist'
                    ) {
                        filteredResults.push(item);
                    } else if (
                        selectedValue === '2' &&
                        item.billetName !== 'ERR Marketing Specialist'
                    ) {
                        filteredResults.push(item);
                    }
                } else if (
                    userBilletLocation === 'Regional' &&
                    selectedAssignmentType === 'ChainOfCommand'
                ) {
                    if (
                        userRegionId === 1 &&
                        item.billetName !== 'WRR Marketing Specialist'
                    ) {
                        filteredResults.push(item);
                    } else if (
                        userRegionId === 2 &&
                        item.billetName !== 'ERR Marketing Specialist'
                    ) {
                        filteredResults.push(item);
                    }
                } else {
                    filteredResults.push(item);
                }
            }
        }
    });

    return filteredResults;
};

export const resetValueAssignedLocation = () => (dispatch, getState) => {
    dispatch(assignmentOptionsSuccess([]));
    dispatch(assigneeOptionsSuccess([]));

    dispatch(actions.change('event.assignmentOption', []));
};

export const assignedLocationUI = () => ({
    type: types.SHOW_HIDE_ASSIGNED_LOCATION
});

export const assignedLocationHide = () => ({
    type: types.HIDE_ASSIGNED_LOCATION
});

export const showHideAssignedLocation = e => (dispatch, getState) => {
    dispatch(resetValueAssignedLocation());
    dispatch(assignedLocationUI());
};

// This will assign the event that has an assigned user selected.
export const assignAssigneeAfterAction = (eventId, assignedUserId) => (
    dispatch,
    getState
) => {
    let postBody = JSON.stringify({
        data: { eventId: eventId, userId: assignedUserId }
    });
    apiRequest(
        `${endpoints.BASE_EVENT_REPORT_PATH}/assign`,
        getState().auth.jwtToken,
        'POST',
        postBody
    ).then(payload => {
        console.log(payload);
    });
};

// This will get the assignee username
export const assigneeUserName = userId => (dispatch, getState) => {
    apiRequest(
        `${
            endpoints.AUTH_USER_SEARCH
        }?fields[User]=id,firstName,lastName,rank&filter[User.id]=${userId}&include=Billet&fields[Billet]=id,name&ver=1`,
        getState().auth.jwtToken,
        'GET',
        undefined,
        false,
        2
    ).then(payload => {
        const dataAtt = payload.data[0];
        const username = `${dataAtt.Billet.name} - ${dataAtt.rank} ${
            dataAtt.firstName
        } ${dataAtt.lastName}`;
        const usernameId = payload.data[0].id;
        dispatch(assigneeUserNameSuccess(username, usernameId));
    });
};

export const assigneeUserNameSuccess = (username, usernameId) => ({
    type: types.ASSIGNEE_USERNAME_SUCCESS,
    username,
    usernameId
});

export const removeAssignee = () => (dispatch, getState) => {
    let postBody = JSON.stringify({
        data: { id: getState().event.EventReport.id }
    });
    apiRequest(
        `${endpoints.BASE_EVENT_REPORT_PATH}/unassign `,
        getState().auth.jwtToken,
        'POST',
        postBody
    ).then(payload => {
        dispatch(assigneeUserNameSuccess(null, null));
    });
};

export const assignedLocationReset = () => (dispatch, getState) => {
    //Set the assignment option dropdown to empty data
    dispatch(assignmentOptionsSuccess([]));
    //Set the assignee option dropdown to empty data
    dispatch(assigneeOptionsSuccess([]));
    //Reset the checkbox Assign After Action to unchecked
    dispatch(assignedLocationHide());
    dispatch(assigneeUserNameSuccess(null, null));
};



// WEBPACK FOOTER //
// ./src/actions/assigned-location.js